import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HomeApi, HomeApiImpl } from './apis/home-api';
import { HomeMaterialApi, HomeMaterialApiImpl } from './apis/home-material-api';
import { HomeService } from './services/home-service';
import { HomeServiceImpl } from './services/impls/home-service';

export const homeContainer = new ContainerModule((bind) => {
  bind(HomeApi).to(HomeApiImpl);
  bind(HomeMaterialApi).to(HomeMaterialApiImpl);
  bind(HomeService).to(HomeServiceImpl);
});
